import { Route } from 'react-router-dom';
import { LazyBrokerPersonaMount } from './LazyBrokerPersonaMount';
import { useBrokerExperienceV2 } from './useBrokerExperienceV2';

/**
 * The `/broker` route, present only when the flag is on. The router renders
 * this unconditionally; the decision lives here, where it can be tested.
 */
export function BrokerRoute() {
  const enabled = useBrokerExperienceV2();

  if (!enabled) {
    return null;
  }
  return <Route path="/broker" component={LazyBrokerPersonaMount} />;
}
